import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import type { ICourseResponse } from "@api/courses/types";
import type { IEnrollmentResponse } from "@api/enrollments/types";
import type {
  ICourseEnrollmentDto,
  ICourseEnrollmentGetAllParams,
} from "@api/courses/enrollments/types";
import { purchase } from "@api/courses/enrollments/purchase/api";
import { request } from "@api/courses/enrollments/request/api";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IEnrollmentResponse, { course: ICourseResponse }>>,
  IPathBaseParam,
  IPaginationParams & ICourseEnrollmentGetAllParams
>("courses.enrollments");
const postApis = createPostApi<
  IApiResponse<IEnrollmentResponse>,
  IPathBaseParam,
  ICourseEnrollmentDto
>("courses.enrollments");
const getApis = createGetApi<
  IApiResponse<IEnrollmentResponse>,
  IPathByIdParam,
  object
>("courses.enrollments");
const patchApis = createPatchApi<
  IApiResponse<IEnrollmentResponse>,
  IPathByIdParam,
  ICourseEnrollmentDto
>("courses.enrollments");

export const enrollments = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  purchase,
  request,
};
